import api from '../../services/api';
import { toast } from 'react-toastify';
import i18n from '../../utils/i18n.ts';

export const fetchRawRegulations = async ({
  pageNumber,
  pageSize,
  searchTerm,
}: {
  pageNumber: number;
  pageSize: number;
  searchTerm?: string;
}) => {
  const params = new URLSearchParams({
    pageNumber: String(pageNumber),
    pageSize: String(pageSize),
    showInactive: 'true',
  });

  const trimmedSearch = searchTerm?.trim();
  if (trimmedSearch) {
    params.set('search', trimmedSearch);
  }

  const response = await api.get(`/regulations?${params.toString()}`);

  if (!response) {
    toast.error(i18n.t('error.api.get-list', { item: i18n.t('module.regulations') }));
  }

  return response.data;
};

export const fetchRawRegulationsById = async (id: number | null) => {
  const response = await api.get(`/regulations/${id}`);
  if (!response) {
    toast.error(i18n.t('error.api.get-item', { item: i18n.t('module.regulation') }));
  }
  return response.data;
};

export const updateRawRegulations = async ({ data }: { data: unknown }) => {
  const response = await api.put(`/regulations`, data);

  if (!response) {
    toast.error(i18n.t('error.api.put-item', { item: i18n.t('module.regulation') }));
  }

  return true;
};

export const exportRawRegulationsCsv = async () => {
  const response = await api.get('/regulations/export/csv', {
    responseType: 'blob',
  });

  if (!response) {
    toast.error(i18n.t('error.api.get-list', { item: i18n.t('module.regulations') }));
    return null;
  }

  return response;
};